import { ArrowRight, Calendar, Filter, Search } from "react-feather";
import styles from "./logfilter.module.css";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";

const LogFilter = ({ filterData, setFilterData, campaignList }) => {
    const [filterOpen, setFilterOpen] = useState(false);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    const handler = setTimeout(() => {
                        setFilterData(prev => {
                            return { ...prev, page: 0, searchKey: e.target.value }
                        });
                    }, 1000);

                    return () => {
                        clearTimeout(handler);
                    }
                }} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Type"
                            onChange={(e) => {
                                setFilterData(prev => {
                                    return { ...prev, page: 0, type: e.target.value }
                                });
                            }}
                        >
                            <MenuItem value="all">All type</MenuItem>
                            <MenuItem value="Prospect">Prospect</MenuItem>
                            <MenuItem value="Tenant">Tenant</MenuItem>
                            <MenuItem value="Contact">Contact</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Campaigns</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Campaigns"
                            value={filterData?.campaign}
                            onChange={(e) => {
                                setFilterData(prev => {
                                    return { ...prev, page: 0, campaign: e.target.value }
                                });
                            }}
                        >
                            <MenuItem value="all">All campaigns</MenuItem>
                            {campaignList?.map(item => {
                                return (item?.is_archived === 0 && item?.is_deleted === 0) ? <MenuItem value={item?.id}>{item?.title}</MenuItem> : null;
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard}`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                        <DateRangePicker
                            format={"M/d/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                            onChange={(e) => {
                                setFilterData(prev => {
                                    return { ...prev, page: 0, submitted: e }
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
        </div>
    </div>)
}

export default LogFilter;